import React, { useState } from "react"
import LinkButton from "@components/common/LinkButton"
import { Link } from 'gatsby'

const WideCard = ({data, cardStyles}) => {
  const [hovered, setHovered] = useState(false)

  return (
    <React.Fragment>
      <div
        className={`relative flex-1 cursor-pointer ${cardStyles && cardStyles}`}
        onClick={data?.onClick}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <Link to={data?.to}>
            <img
            className={`w-full h-full object-cover object-top`}
            src={data?.image}
            alt={data?.name}
            />
        </Link>
        {data?.description && (
          <p className="product-description">{data?.description}</p>
        )}

        <LinkButton
          label={data?.buttonLabel}
          className={`mt-4 ${hovered ? 'underline font-semibold underline-offset-4' : 'font-normal'} block w-full text-center`}
          to={data?.to}
        />
      </div>
    </React.Fragment>
  );
}

export default WideCard